<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block prava-djelatnika-naslov">
    PRAVA DJELATNIKA
    <div>
      <dx-button type="button" class="desno" (click)="backButtonClicked()">
        <b>Nazad</b>
      </dx-button>
    </div>
  </h2>
  <div class="customTable popisDjelatnika m-40">
    <dx-data-grid
      [dataSource]="sviModuli"
      [wordWrapEnabled]="true"
      [showColumnLines]="true"
      [showBorders]="false"
      (onToolbarPreparing)="onToolbarPreparing($event)"
    >
      <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
        <div class="naslov">
          <h2 class="mb-0" style="padding-right: 30px">Prava djelatnika</h2>
          <p class="mt-0">Popis prava svih djelatnika</p>
        </div>

        <dx-select-box
          [dataSource]="sveGrupe"
          displayExpr="sgr_naziv"
          valueExpr="idsec_group"
          placeholder="Grupe korisnika"
          [value]="idGrupa"
          (onValueChanged)="odabranaGrupa($event)"
          style="width: 250px; height: fit-content; scrollbar-width: none"
        >
        </dx-select-box>
      </div>

      <dxo-search-panel
        [visible]="true"
        [width]="180"
        placeholder="Pretraži..."
      >
      </dxo-search-panel>

      <dxo-paging [enabled]="true" [pageSize]="75"></dxo-paging>

      <!-- <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[15, 30, 45]"
      [showInfo]="true"
    >
    </dxo-pager> -->

      <!-- MODUL -->
      <dxi-column
        class="modul-name"
        dataField="smo_ime"
        caption="Modul"
        [minWidth]="300"
      ></dxi-column>

      <!-- BEZ PRAVA -->
      <dxi-column
        dataField="sgm_prava"
        caption="Nema prava"
        [minWidth]="50"
        alignment="center"
        cellTemplate="bezPrava"
      ></dxi-column>

      <!-- BEZ PRAVA  -->
      <div *dxTemplate="let row of 'bezPrava'">
        <div *ngIf="row.data.sgm_prava==0">
          <dx-check-box [value]="row.data.sgm_prava == 0"> </dx-check-box>
        </div>

        <div *ngIf="row.data.sgm_prava!=0">
          <div>
            <dx-check-box
              (onValueChanged)="promjeniPrava($event, row, 0)"
            ></dx-check-box>
          </div>
        </div>
      </div>

      <!-- PRAVA PREGLEDA -->
      <dxi-column
        dataField="sgm_prava"
        caption="Prava pregleda"
        [minWidth]="50"
        alignment="center"
        cellTemplate="pravaPregleda"
      ></dxi-column>

      <div *dxTemplate="let row of 'pravaPregleda'">
        <div *ngIf="row.data.sgm_prava==1">
          <dx-check-box [value]="row.data.sgm_prava == 1"> </dx-check-box>
        </div>

        <div *ngIf="row.data.sgm_prava!=1">
          <div>
            <dx-check-box
              (onValueChanged)="promjeniPrava($event, row, 1)"
            ></dx-check-box>
          </div>
        </div>
      </div>

      <!-- SVA PRAVA -->
      <dxi-column
        dataField="sgm_prava"
        caption="Sva prava"
        [minWidth]="50"
        alignment="center"
        cellTemplate="svaPrava"
      ></dxi-column>

      <div *dxTemplate="let row of 'svaPrava'">
        <div *ngIf="row.data.sgm_prava==2">
          <dx-check-box [value]="row.data.sgm_prava == 2"> </dx-check-box>
        </div>

        <div *ngIf="row.data.sgm_prava!=2">
          <div>
            <dx-check-box
              (onValueChanged)="promjeniPrava($event, row, 2)"
            ></dx-check-box>
          </div>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>
